/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-17
 * @brief EHP Login-비밀번호 찾기 레이어 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
//
import { useRecoilValue } from "recoil";
// recoil
import { getApiLangState } from "../../recoil/langState";
import $ from "jquery";
//import "/static/css/login.css"
// recoil
// utils
import { useTrans } from "../../utils/langs/useTrans";
import * as HttpUtil from "../../utils/api/HttpUtil";
import clog from "../../utils/logUtils";
/**
 * @brief EHP 비밀번호 찾기 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function FindPw(props) {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    //
    const isRunYn = props.isRunYn;
    const layerList = props.layerList;
    const [isFindPw, setIsFindPw] = useState(isRunYn); // false
    const [userId, setUserId] = useState("barsk@hanmail.net"); //test@test.com
    const [userName, setUserName] = useState("bsKimH"); //bsKim
    const [userPhone, setUserPhone] = useState("01012345678"); //01000000001
    const [resErrorCode, setResErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState([{ "field": "", "msg": "" }]);
    const [resUserIdMsg, setUserIdMsg] = useState(""); //test@test.com
    const [resUserNameMsg, setUserNameMsg] = useState(""); //bsKim
    const [resPhoneNumberMsg, setPhoneNumberMsg] = useState(""); //01000000001
    //20220824 추가
    const [errorList, setErrorList] = useState([]);
    const t = useTrans();
    // useAsync call axios
    const { data: data, error, isLoading, reload, run } = useAsync({
        //promiseFn: HttpUtil.getUsers,
        deferFn: HttpUtil.Http,
        httpMethod: "PUT",
        appPath: "/api/v2/auth/password/init",
        appQuery: {
            userId: userId,
            userName: userName,
            phoneNumber: userPhone,
            language: apiLang
        },
    });
    if (isLoading) {
        React.createElement(React.Fragment, null, "loading ......");
    }
    useEffect(() => {
        if (data) {
            if (data.codeNum == 200) {
                setResErrorCode(200);
                setUserIdMsg("아래 메일 주소로 새 비밀번호가 전송 되었으니, 로그인 후 비밀번호를 변경해 주세요.");
                setIsFindPw(true);
                // } else if (data.errorList !== null) {
            }
            else {
                setResErrorCode(data.codeNum);
                //20220824 추가
                setErrorList(data.errorList);
                setResErrorMsg(data.errorList);
                clog("에러 사유 : " + data.errorList);
                setUserIdMsg("");
                setUserNameMsg("");
                setPhoneNumberMsg("");
                /* data.errorList.map((errMsg) => {
                  (errMsg.field === "userId") && setUserIdMsg(errMsg.msg);
                  (errMsg.field === "userName") && setUserNameMsg(errMsg.msg);
                  (errMsg.field === "phoneNumber") && setPhoneNumberMsg(errMsg.msg);
                }); */
            }
            //////////// 추후 Api 수정 시 else if -> else로 바꾸고 밑에 코드 삭제
            //2022 06 16 수정
            /* else {
              clog("또 에러가 나는가? : " + data.codeNum);
              clog("또 에러가 나는가? : " + data.codeNum);
              setUserIdMsg("모든 항목 필수 입력 입니다.");
              setUserNameMsg("모든 항목 필수 입력 입니다.");
              setPhoneNumberMsg("모든 항목 필수 입력 입니다.");
      
            } */
            ///////////////////////////////////////
        }
    }, [data]);
    // function layerClose(tagId) {
    //   var othLayer = tagId;
    //   //닫기 버튼 , 배경 클릭 시
    //   $("#" + othLayer)
    //     .children()
    //     .children(".js-close")
    //     .trigger("click", function (ee) {
    //       $("#" + othLayer).addClass("hidden"); //모든 팝업 감추기
    //       $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
    //     });
    //   //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
    //   $("#" + othLayer + ".layer-out")
    //     .children()
    //     .children(".js-close")
    //     .on("click", function (ee) {
    //       $(".dimm").stop().hide().css("z-index", "11");
    //     });
    // }
    function layerClose(tagId) {
        var othLayer = tagId;
        //닫기 버튼 , 배경 클릭 시
        $("#" + othLayer)
            .children()
            .children(".js-close")
            .trigger("click", function (ee) {
            $("#" + othLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + othLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    function layerOpen(e) {
        e.preventDefault();
        var actTag = (e.target.tagName == "BUTTON") ? e.target : e.currentTarget;
        var activeLayer = actTag.getAttribute("data-pop");
        //
        layerList.map((olayer) => {
            layerClose(olayer);
        });
        // 레이어 팝업 화면 가운데 정렬
        $("#" + activeLayer + ".popup-layer").css("position", "absolute");
        $("#" + activeLayer + ".popup-layer").css("top", ($(window).height() - $("#" + activeLayer).outerHeight()) / 2 + $(window).scrollTop() + "px");
        $("#" + activeLayer + ".popup-layer").css("left", ($(window).width() - $("#" + activeLayer).outerWidth()) / 2 + $(window).scrollLeft() + "px");
        // $(".popup-layer").addClass("hidden"); //모든 팝업 감추기(팝업안에 팝업이 또 있을때는 해당 안됨)
        $("#" + activeLayer).removeClass("hidden"); //호출한 팝업만 부르기
        $(".dimm").stop().show().css("z-index", "30"); //배경 가져오기
        $("body").css("overflow-y", "hidden"); //body 스크롤 숨기기(화면고정)
        //닫기 버튼 , 배경 클릭 시
        $("#" + activeLayer)
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $("#" + activeLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + activeLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    function onClickCancelPw(e) {
        setResErrorCode(200);
        setIsFindPw(false);
        setUserId("");
        setUserName("");
        setUserPhone("");
        setUserIdMsg("");
        setUserNameMsg("");
        setPhoneNumberMsg("");
        //20220824 추가
        setErrorList([]);
        layerList.map((olayer) => {
            layerClose(olayer);
        });
    }
    function handleSetUserId(val) {
        setErrorList(errorList.filter((err) => (err.field !== "userId")));
        setUserId(val);
    }
    function handleSetUserName(val) {
        setErrorList(errorList.filter((err) => (err.field !== "userName")));
        setUserName(val);
    }
    function handleSetPhoneNumber(val) {
        setErrorList(errorList.filter((err) => (err.field !== "phoneNumber")));
        setUserPhone(val);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "findPw", className: "popup-layer js-layer layer-out hidden login__popup" },
            " ",
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => onClickCancelPw(e) },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                (!isFindPw) &&
                    React.createElement("form", { action: "", method: "", name: "popfindpw" },
                        React.createElement("ul", { className: "form__input" },
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userId", className: "star" }, "\uC544\uC774\uB514"),
                                React.createElement("div", { className: "input__area" },
                                    " ",
                                    React.createElement("input", { type: "text", id: "findUserId", placeholder: "ex) abc@company.com", value: userId, 
                                        //className={(resUserIdMsg.length <= 0) ? "" : "input-error"}
                                        className: (errorList.filter(err => (err.field === "userId")).length > 0) ? "input-error" : "", onChange: (e) => handleSetUserId(e.target.value) }),
                                    "  ",
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "userId")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "username2", className: "star" }, "\uC774\uB984"),
                                React.createElement("div", { className: "input__area" },
                                    " ",
                                    React.createElement("input", { type: "text", id: "username2", placeholder: "\uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694", value: userName, 
                                        //className={(resUserNameMsg.length <= 0) ? "" : "input-error"}
                                        className: (errorList.filter(err => (err.field === "userName")).length > 0) ? "input-error" : "", onChange: (e) => handleSetUserName(e.target.value) }),
                                    "  ",
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "userName")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userphone1", className: "star" }, "\uC5F0\uB77D\uCC98"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "tel", id: "userphone1", placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694", value: userPhone, 
                                        //className={(resPhoneNumberMsg.length <= 0) ? "" : "input-error"}
                                        className: (errorList.filter(err => (err.field === "phoneNumber")).length > 0) ? "input-error" : "", onChange: (e) => handleSetPhoneNumber(e.target.value) }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "phoneNumber")).map((err) => err.msg)))))),
                (isFindPw) &&
                    React.createElement("div", { className: "complete-txt" },
                        " ",
                        React.createElement("p", { className: "tit" }, resUserIdMsg),
                        React.createElement("p", null, userId))),
            React.createElement("div", { className: "popup__footer" },
                (!isFindPw) && React.createElement("button", { type: "button", className: "js-close bg-gray", onClick: (e) => onClickCancelPw(e) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
                (!isFindPw) && React.createElement("button", { type: "button", onClick: run },
                    React.createElement("span", null, "\uCC3E\uAE30")),
                (isFindPw) && React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickCancelPw(e) },
                    React.createElement("span", null, "\uD655\uC778"))))));
}
export default FindPw;
